/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionAdditionalPaymentData
 */
export interface SubscriptionAdditionalPaymentData {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAdditionalPaymentData
     */
    amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAdditionalPaymentData
     */
    isAdditionalPaymentNeeded?: boolean;
}

/**
 * Check if a given object implements the SubscriptionAdditionalPaymentData interface.
 */
export function instanceOfSubscriptionAdditionalPaymentData(value: object): value is SubscriptionAdditionalPaymentData {
    return true;
}

export function SubscriptionAdditionalPaymentDataFromJSON(json: any): SubscriptionAdditionalPaymentData {
    return SubscriptionAdditionalPaymentDataFromJSONTyped(json, false);
}

export function SubscriptionAdditionalPaymentDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionAdditionalPaymentData {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'isAdditionalPaymentNeeded': json['isAdditionalPaymentNeeded'] == null ? undefined : json['isAdditionalPaymentNeeded'],
    };
}

export function SubscriptionAdditionalPaymentDataToJSON(json: any): SubscriptionAdditionalPaymentData {
    return SubscriptionAdditionalPaymentDataToJSONTyped(json, false);
}

export function SubscriptionAdditionalPaymentDataToJSONTyped(value?: SubscriptionAdditionalPaymentData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'isAdditionalPaymentNeeded': value['isAdditionalPaymentNeeded'],
    };
}

